export default __webpack_public_path__ + "static/media/Outcome of Board Meeting_Feb 06, 2026.256bc6c2.pdf";